// La vista de manejo es MapLibre (WebGL). Sin WebGL —aceleración por hardware
// apagada en Chrome, GPU en la lista negra, políticas de empresa— `new Map()`
// lanza «Failed to initialize WebGL» y la pantalla quedaba en blanco (un
// compañero de Daniel, 30-oct, con GL_RENDERER = Disabled). En esos navegadores
// la función no existe: ni botón ni apertura sola.
let supported: boolean | undefined;

/** ¿Este navegador puede crear el contexto WebGL que pide MapLibre? Se mide una vez. */
export function canDrawDriveView(): boolean {
  if (supported !== undefined) return supported;
  try {
    const canvas = document.createElement("canvas");
    // Las mismas opciones que MapLibre 4 (failIfMajorPerformanceCaveat: false): con
    // render por software (SwiftShader) sí abre; lo que se oculta es lo que truena.
    const gl = (canvas.getContext("webgl2") || canvas.getContext("webgl")) as WebGLRenderingContext | null;
    supported = !!gl;
    // Suelta el contexto ya: Chrome limita a ~16 por página y tira el más viejo.
    gl?.getExtension("WEBGL_lose_context")?.loseContext();
  } catch {
    supported = false;
  }
  return supported;
}
